import { __ } from '@wordpress/i18n';
import React from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import ErrorProvider from '@/services/context/Woocommerce/ErrorProvider';
import WoocomerceProvider from '@/services/context/Woocommerce/WoocomerceProvider';
import ErrorBoundary from './ErrorHandling';

import Page from './components/Page';
import FoamiteProductsList from './views/Products/FoamiteProductsList';

// Exact copy of shapes-list.tsx, mounting FoamiteProductsList (which reads
// fmtCustomShapesData) into the Foamite Shapes List template's mount point
// instead of ProductsList/fmtshapesdata. Same provider stack, so pages
// using this template render with the same look/behavior as the existing
// foam/mattress/cushions shapes-list pages.
document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('fmt-custom-shapes-list');
    const settings = {};

    if (el) {
        const root = createRoot(el);

        root.render(
            <React.Fragment>
                <ErrorBoundary>
                    <CssBaseline />
                    {/* Woocommerce Client Context Provider */}
                    <WoocomerceProvider value={null}>
                        {/* Error Client Context Provider */}
                        <ErrorProvider>
                            <Page>
                                <FoamiteProductsList />
                            </Page>
                        </ErrorProvider>
                    </WoocomerceProvider>
                </ErrorBoundary>
            </React.Fragment>,
        );
    }
});
